module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('static.products.index.importProductsErrorPopupTitle')))]), _vm._v(" "), _c('ul', _vm._l((_vm.errors), function(error) {
    return _c('li', {
      key: error.row,
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_c('div', {
      staticClass: "flex",
      staticStyle: {
        "align-items": "flex-start"
      }
    }, [_c('div', [_vm._v(_vm._s(_vm.$t('static.products.index.row')) + " " + _vm._s(error.row) + " - ")]), _vm._v(" "), _c('div', _vm._l((error.errors), function(err) {
      return _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(err[0])
        }
      })])
    }), 0)])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3af459cb","hasScoped":false}!./src/app/components/clientImportExportErrorReportPopup/clientImportExportErrorReportPopup.html
// module id = 2973
// module chunks = 1